<div>
  <label class="label-input" *ngIf="showLabel">
    <span *ngIf="showLabel"> {{ label | translate }}</span>
    <span *ngIf="checkRequire()" class="p-errors" style="color: red; margin-left: 3px">*</span></label
  >
  <p-calendar
    #calendar
    styleClass="w-full"
    [locale]="viLocale"
    (keydown.space)="$event.preventDefault()"
    (onBlur)="onTouched(); onBlur($event)"
    (onInput)="onInput($event)"
    [dateFormat]="dateFormat"
    [firstDayOfWeek]="1"
    [formControl]="control"
    [keepInvalid]="true"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
    [readonlyInput]="readonly"
    [selectionMode]="selectionMode"
    [showIcon]="!readonly"
    [showOnFocus]="true"
    [timeOnly]="false"
    [view]="view"
    [showTime]="showTime"
    [readonlyInput]="true"
    [showClear]="showClear || hasValue"
    icon="pi pi-calendar"
    appendTo="body"
  >
  </p-calendar>
  <div class="relative b-errors">
    <ng-container *ngIf="errors">
      <small class="p-error error-msg block fadeinup animation-duration-300">
        <span class="block">{{ displayedErrorMessage }}</span>
      </small>
    </ng-container>
  </div>
</div>
